// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import LandingMap from "nextus/Maps/LandingMap";

// API/MODELS
import deviceAPI from "api/bks";
import MapNav from "nextus/Sidenavs/MapNav";
import EventsBar from "modules/clearways/views/EventsBar";
import { Grid } from "@mui/material";

import clearwaysAPI from "modules/clearways/api";
import { processEventsData } from "helper/event";
import { set } from "date-fns";

function wrapper(map, eventBar, deviceStyle) {
    if (deviceStyle == 'desktop') {
        return (
            <Grid container sx={{ height: '100%' }}>
                <Grid item xxs={12} pb={1}>
                    {map}
                </Grid>
                {/* <Grid item xxs={12} pt={1}>
                    {eventBar}
                </Grid> */}
            </Grid>
        )
    }
    else {
        return (
            <SoftBox sx={{ height: '100%', paddingBottom: '8px' }}>
                {map}
            </SoftBox>
        )
    }
}

function MapMenuContent({ sidebarOpen, setSidebarOpen, groupPreviewID = 0, events, eventbarState, setEventbarState, sidebarState, deviceStyle = "desktop" }) { // LAYER 3

    return (
        wrapper(
            (<MapNav sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} groupPreviewID={groupPreviewID} sidebarState={sidebarState} events={events} eventbarState={eventbarState} setEventbarState={setEventbarState} />),
            (<EventsBar events_data={events} eventbarState={eventbarState} setEventbarState={setEventbarState} sidebarState={sidebarState} />), // INTO LAYER 4
            (deviceStyle)
        )
    );
}

MapMenuContent.propTypes = {
    sidebarOpen: PropTypes.bool,
    setSidebarOpen: PropTypes.func,
    groupPreviewID: PropTypes.number,
    events: PropTypes.array,
    eventbarState: PropTypes.string,
    setEventbarState: PropTypes.func,
    sidebarState: PropTypes.string,
}

export default MapMenuContent;